<template>
  <div id="app" style="height: 100%; width: 100%">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: "App",
    watch: {
      $route(to, from) {
        if (to.path != "/") {
          if(to.meta.title == '' || typeof to.meta.title == 'undefined' || to.meta.title == null){
            return;
          }
          let obj = {
            name: to.name,
            title: to.meta.title,
          };

          this.$store.commit("addTab", obj)
        }
      },
    },
  };
</script>

<style>
  html,
  body,
  #app {
    font-family: "Helvetica Neue", "Hiragino Sans GB", "WenQuanYi Micro Hei",
    "Microsoft Yahei", sans-serif;
    height: 100%;
    padding: 0;
    margin: 0;
    font-size: 15px;
  }
</style>
